export default [
  {
    path: '/bank',
    name: 'list-bank',
    component: () => import('@/views/bank/List.vue'),
    meta: {
      pageTitle: 'breadcrumb.bank',
      resource: 'bank-setting',
      action: 'read',
      breadcrumb: [
        {
          text: 'breadcrumb.listBank',
          active: true,
        },
      ],
    },
  },
  {
    path: '/bank/create',
    name: 'create-bank',
    component: () => import('@/views/bank/Create.vue'),
    meta: {
      pageTitle: 'breadcrumb.bank',
      navActiveLink: 'list-bank',
      resource: 'bank-setting',
      action: 'create',
      breadcrumb: [
        {
          text: 'breadcrumb.listBank',
          to: { name: 'list-bank' },
        },
        {
          text: 'breadcrumb.createBank',
          active: true,
        },
      ],
    },
  },
  {
    path: '/bank/:id/update',
    name: 'update-bank',
    component: () => import('@/views/bank/Update.vue'),
    meta: {
      pageTitle: 'breadcrumb.bank',
      navActiveLink: 'list-bank',
      resource: 'bank-setting',
      action: 'update',
      breadcrumb: [
        {
          text: 'breadcrumb.listBank',
          to: { name: 'list-bank' },
        },
        {
          text: 'breadcrumb.updateBank',
          active: true,
        },
      ],
    },
  },
  {
    path: '/bank/:id',
    name: 'view-bank',
    component: () => import('@/views/bank/View.vue'),
    meta: {
      pageTitle: 'breadcrumb.bank',
      navActiveLink: 'list-bank',
      resource: 'bank-setting',
      action: 'read',
      breadcrumb: [
        {
          text: 'breadcrumb.listBank',
          to: { name: 'list-bank' },
        },
        {
          text: 'breadcrumb.viewBank',
          active: true,
        },
      ],
    },
  },
]
